
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12324',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12324",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9681",
  "foundations-components": "static-1.7964",
  "foundations-components-legacy": "static-1.989",
  "foundations-theming": "static-1.4433",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8027",
  "hub-http-shared-msw-handlers": "static-1.10000",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11485",
  "I18n": "static-7.1628",
  "jasmine-runner": "static-1.6477",
  "marketplace-storefront-base": "static-1.12385",
  "quartz": "static-1.7050",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16685",
  "reactive-variable-buffer-atom": "static-1.2872",
  "reporting-testing-lib": "static-1.9555",
  "settings-ui-lib": "static-1.12534",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7164",
  "ui-addon-i18n": "static-1.11162",
  "ui-addon-react-router-dom": "static-1.9555",
  "unified-auth": "static-1.508",
  "unified-auth-core-lib": "static-1.790",
  "usage-tracker": "static-1.7359",
  "usage-tracker-core": "static-1.7209",
  "customer-data-property-utils": "static-1.8104",
  "hub-http": "static-1.6235",
  "integrations-lib": "static-1.16202",
  "marketplace-ui-common": "static-1.19771",
  "property-management-iframe": "static-1.13213",
  "quartz-config": "static-1.828",
  "quartz-core": "static-1.6269",
  "quartz-routing": "static-1.480",
  "quick-fetch": "static-1.3925",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4666",
  "ts-schema": "static-1.4088",
  "ui-universal-auth": "static-1.8994",
  "UIComponents": "static-3.8431",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3408",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3327",
  "quartz-webpack": "static-1.3274",
  "bend-plugin-quartz-routing": "static-1.128",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4233",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4880",
  "foundations-theming-specialty": "static-1.2149",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9438",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5353",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1989",
  "ui-fonts": "static-1.747",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-theming": "static-1.2916",
  "foundations-theming-base": "static-1.3418",
  "stylex": "static-1.33",
  "HeadJS": "static-2.762",
  "hs-test-utils-bend-plugin": "static-1.3138",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4341",
  "ai-components-ui-library": "static-1.9022",
  "ai-rendering-library": "static-1.10234",
  "chirp-fetch": "static-1.1901",
  "connections-embed-lib": "static-1.1015",
  "copilot-toolkit": "static-1.11175",
  "feedback-loader": "static-1.29320",
  "laboratory-lib": "static-3.7169",
  "marketplace-embed": "static-1.22141",
  "marketplace-ui-details": "static-1.9667",
  "marketplace-ui-reviews": "static-1.19727",
  "marketplace-ui-tracking": "static-1.13942",
  "sanitize-text": "static-1.8155",
  "ui-addon-video-player": "static-1.8716",
  "usage-tracker-multi": "static-1.5773",
  "usage-tracker-session-replay": "static-1.5045",
  "wootric-nps": "static-1.6988",
  "quartz-head": "static-1.715",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4665",
  "immer": "static-1.33",
  "immerable": "static-1.4167",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2499",
  "reporting-data": "static-1.67622",
  "cssUtils": "static-1.794",
  "flux-actions": "static-1.338",
  "HubStyle": "static-2.11792",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10220",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10379",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7349",
  "icons": "static-2.648",
  "marketplace-ui-apps-core": "static-1.18304",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4529",
  "foundations-components-test-utils": "static-1.5447",
  "quartz-i18n": "static-1.725",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.290",
  "microsoft-drive-integration-lib": "static-1.416",
  "slack-ui-library": "static-1.10406",
  "fsm": "static-1.3744",
  "customer-data-objects": "static-1.7683",
  "property-translator": "static-1.5413",
  "hs-locale-management": "static-1.89",
  "frontend-preferences-client": "static-1.7941",
  "hs-promise-utils": "static-1.5604",
  "hubspot-apollo-client": "static-1.4893",
  "integrations-error-boundary-lib": "static-1.13617",
  "integrations-tracking-lib": "static-1.5614",
  "native-integrations-shared-strings": "static-1.7795",
  "reselect": "static-2.16",
  "sanitize": "static-1.4490",
  "superstore": "static-1.4775",
  "ui-shepherd-react": "static-3.10178",
  "ai-settings-ui-library": "static-1.7907",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4660",
  "immutable-less": "static-1.4667",
  "marketplace-ui-client-types": "static-1.17178",
  "nav-meta": "static-1.29721",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10261",
  "ui-addon-upgrades": "static-9.18015",
  "inbound-db-properties-service-client": "static-1.3854",
  "property-management-common": "static-1.5501",
  "ui-addon-iframeable": "static-1.9071",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.725",
  "quartz-test": "static-1.725",
  "quartz-tracking": "static-1.429",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.76",
  "bender-build-tools": "static-1.3215",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21399",
  "ContentUtils": "static-1.68415",
  "customer-data-objects-ui-components": "static-1.13041",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.63",
  "avatar-components": "static-1.2511",
  "customer-data-filters-ui": "static-1.39852",
  "customer-data-reference-ui-components": "static-1.13178",
  "embedded-academy-lib": "static-1.14395",
  "ExportDialog": "static-6.10400",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41349",
  "reporting-snowflake": "static-1.56240",
  "reporting-ui-components": "static-2.64893",
  "reporting-visualizations": "static-1.59698",
  "ui-addon-teams": "static-1.21573",
  "magpie-lib": "static-1.5561",
  "navigation-components": "static-1.18084",
  "magpie-types": "static-1.5021",
  "simple-logging-lib": "static-1.3064",
  "ai-studio-lib": "static-1.11663",
  "app-governance-lib": "static-1.1592",
  "developer-experience-shared-components": "static-1.10523",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8012",
  "ui-product-approvals": "static-1.28173",
  "ui-tool-access": "static-1.10161",
  "usage-based-billing-components-lib": "static-1.8971",
  "usage-tracker-anonymous": "static-1.5776",
  "usage-tracker-public": "static-1.7170",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3594",
  "persist-promise": "static-1.3712",
  "reference-resolvers": "static-1.8184",
  "ui-extensibility-client-types": "static-1.3936",
  "hubspot-apollo-cache": "static-1.352",
  "universal-page-editor-lib": "static-1.3026",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2829",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5086",
  "purchase-motions-components": "static-1.5930",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1555",
  "crm-component-utils": "static-1.39124",
  "crm-properties-common-lib": "static-1.5898",
  "customer-data-properties": "static-1.51611",
  "framework-data-schema-resolvers": "static-1.6898",
  "property-value-citations": "static-1.2225",
  "reference-resolvers-lite": "static-1.8108",
  "ui-business-units-lib": "static-1.9067",
  "navigation-messaging": "static-1.7411",
  "hubspotter-http-shared-msw-handlers": "static-1.9998",
  "cms-field-types": "static-1.4826",
  "content-icons-ui": "static-1.2229",
  "customer-data-ui-utilities": "static-1.9840",
  "events-data-lib": "static-1.235",
  "conversations-skeleton-state": "static-1.7260",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22287",
  "FormUrlGenerator": "static-2.4732",
  "framework-builder-read-service-client": "static-1.4013",
  "framework-data-schema-quick-fetch": "static-1.6803",
  "multi-account-reference-resolvers": "static-1.993",
  "onboarding-tours": "static-1.16640",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13733",
  "academy-common-lib": "static-1.13855",
  "content-assistance-lib": "static-1.7773",
  "dashboard-lib": "static-1.81598",
  "file-manager-components": "static-1.23669",
  "getting-started-shared-tasks": "static-1.18507",
  "hubspot-prosemirror": "static-1.18278",
  "hubspot-prosemirror-plugins": "static-1.18270",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19860",
  "share-with-third-party-component-lib": "static-1.8715",
  "ui-addon-draggable": "static-3.4776",
  "ui-asset-management-lib": "static-1.11053",
  "user-context": "static-1.5119",
  "growth-payments-core": "static-1.25430",
  "reporting-plugins": "static-1.10345",
  "reporting-reports": "static-1.67300",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.737",
  "nest": "static-1.241",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10640",
  "framework-listing-lib": "static-2.28757",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30755",
  "apps-service-types": "static-1.3891",
  "oauth-service-types": "static-1.4262",
  "ui-product-approvals-common": "static-1.68",
  "onboarding-scopes": "static-1.6475",
  "onboarding-tours-client": "static-1.4854",
  "platform-infra-nav-components": "static-1.7679",
  "subscription-experience-data-types": "static-1.14953",
  "crm-record-cards-service-types": "static-1.3605",
  "location-customization-utils-lib": "static-1.9313",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5933",
  "signup-constants": "static-1.18866",
  "signup-ui-url-generator": "static-2.8065",
  "trials-service-types": "static-1.3916",
  "card-properties-lib": "static-1.44247",
  "commerce-subscription-lib": "static-1.37171",
  "crm-actions": "static-1.6339",
  "crm-cards-sdk": "static-1.43639",
  "customer-data-properties-shared-msw-handlers": "static-1.9327",
  "customer-data-tracking": "static-1.6903",
  "hs-resources": "static-1.166",
  "pulse": "static-1.588",
  "calling-global-api": "static-1.64567",
  "calling-internal-common": "static-1.31316",
  "calling-lifecycle-internal": "static-1.65949",
  "calling-lifecycle-messages": "static-1.58243",
  "commerce-products-lib": "static-1.9631",
  "conditional-properties-service-client": "static-1.3805",
  "crm-links": "static-1.6307",
  "external-options-client-types": "static-1.4167",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4231",
  "meetings-icalendar-utils-lib": "static-1.645",
  "multi-currency-client-types": "static-1.3699",
  "object-builder-ui-client": "static-1.48803",
  "pipeline-validation-client-types": "static-1.3973",
  "smart-property-lib": "static-1.7158",
  "tiered-pricing": "static-1.1251",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11003",
  "crm-pipelines-api-client-types": "static-1.4147",
  "fdsr-migration-layer": "static-1.17",
  "react-dnd-compat": "static-1.4628",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.921",
  "growth-data-modal": "static-1.5450",
  "growth-onboarding-confetti": "static-1.3080",
  "growth-onboarding-next-action-utils": "static-1.1970",
  "onboarding-tours-utils": "static-1.706",
  "ui-shepherd-tracker": "static-1.7559",
  "academy-service-client": "static-1.3694",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39168",
  "FileManagerLib": "static-1.39309",
  "video-embed": "static-1.35821",
  "ui-coaching-tips": "static-1.28609",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11329",
  "video-data-lib": "static-1.34987",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23589",
  "ui-addon-emoji-picker": "static-1.9901",
  "EmailSignatureEditor": "static-1.24404",
  "viral-links-lib": "static-1.7079",
  "data-token-picker": "static-1.16433",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.240",
  "timezone-utils": "static-2.5258",
  "seat-types-lib": "static-1.49",
  "getting-started-shared-tasks-store": "static-1.17625",
  "ui-addon-opt": "static-4.8379",
  "campaign-roi-lib": "static-1.9171",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7339",
  "customer-data-views-management": "static-1.25493",
  "framework-data-table": "static-2.11949",
  "marketing-platform-lib": "static-1.6871",
  "nudge-client-utils": "static-1.2616",
  "nudge-custom-ui-functions": "static-1.1046",
  "app-users-service-client": "static-1.5611",
  "app-users-service-types": "static-1.5019",
  "mini-checkout-client": "static-1.26845",
  "onboarding-utils": "static-1.5367",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28594",
  "edison-service-client-types": "static-1.401",
  "crm_data": "static-4.92020",
  "customer-data-sidebar": "static-2.46065",
  "enrichment-properties-lib": "static-1.16276",
  "ui-addon-draggable-compat": "static-2.4270",
  "commerce-billing-lib": "static-1.19123",
  "commerce-shared-components-lib": "static-1.18584",
  "commerce-tools-ui-lib": "static-1.10421",
  "crm-fe-perf": "static-1.22917",
  "bend-plugin-pulse": "static-1.91",
  "directed-graph": "static-1.949",
  "event-emitter": "static-1.961",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31323",
  "shared-worker-versioning": "static-1.11050",
  "calling-usage-tracker": "static-1.6555",
  "voice-sms-access-library": "static-1.1034",
  "commerce-permissions": "static-1.783",
  "products-iframe-lib": "static-1.7984",
  "products-ui-components-shared-msw-handlers": "static-1.10382",
  "data-agent-kit": "static-1.216",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10083",
  "policy-lib": "static-1.6791",
  "react-tinymce": "static-1.55291",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10146",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54417",
  "tinymce-plugins": "static-1.57531",
  "tinymce-themes": "static-1.56387",
  "onboarding-data-sync-lib": "static-1.1979",
  "growth-onboarding-next-action-components": "static-1.1998",
  "user-context-client": "static-1.4626",
  "audio-components": "static-1.5935",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36820",
  "urlinator": "static-1.4550",
  "video-components": "static-1.13332",
  "outpost": "static-1.4194",
  "growth-onboarding-feedback-components": "static-1.6594",
  "content-media-composition-data-lib": "static-1.12373",
  "content-media-compositions": "static-2.16380",
  "media-bridge-lib": "static-1.18952",
  "commerce-tours-lib": "static-1.6129",
  "growth-onboarding-reliability": "static-1.5096",
  "sales-checkout-service-client": "static-1.3654",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21702",
  "sales-email-signature-service-client": "static-1.3856",
  "ts-utils-lib": "static-1.186",
  "breeze-engine-lib": "static-1.706",
  "crm-export-dialog": "static-1.6305",
  "crm-index-associations-lib": "static-1.6454",
  "crm-view-components": "static-1.307",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2373",
  "nudge-renderer-utils": "static-1.2692",
  "whisper-core-api": "static-1.6671",
  "InboxConnectUtils": "static-4.14861",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5585",
  "settings-content-modals": "static-1.46133",
  "crm_universal": "static-1.22033",
  "customer-data-email": "static-1.18060",
  "card-payment-highlight-lib": "static-1.37225",
  "card-subscription-highlight-lib": "static-1.39594",
  "commerce-contract-lib": "static-1.12123",
  "invoices-highlight-card-lib": "static-1.54780",
  "orders-highlight-card-lib": "static-1.21518",
  "products-highlight-card-lib": "static-1.17914",
  "quotes-highlight-card-lib": "static-1.72102",
  "crm-source-interpretation-lib": "static-1.5356",
  "utility-belt": "static-1.2548",
  "payments-enrollment-embed-lib": "static-1.22948",
  "stripe-embedded-components": "static-1.7531",
  "customer-data-rte": "static-1.33042",
  "cv-backend-services": "static-1.1553",
  "growth-onboarding-empty-states": "static-1.5757",
  "payments-post-enroll-local-storage-lib": "static-1.5122",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38192",
  "calling-orchestration-schema": "static-1.35811",
  "sales-views-client-types": "static-1.4272",
  "hub-http-contrib": "static-1.3056",
  "interframe": "static-3.4773",
  "tinymce-data": "static-1.40502",
  "ui-addon-sales-email": "static-1.5224",
  "layout-dnd-components": "static-1.12473",
  "layout-dnd-utils": "static-1.11448",
  "ui-brand-identity-lib": "static-1.15341",
  "NamespacedHubStyle": "static-2.9067",
  "meetings-connect-utils-lib": "static-1.7619",
  "social-insights-client-types": "static-1.22165",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4155",
  "checkout-sdk": "static-3.23688",
  "checkout-service-types": "static-1.3829",
  "company-details-components": "static-1.6209",
  "payment-method-components": "static-1.6920",
  "pricing-pages-ui-components": "static-1.14085",
  "quote-checkout-service-types": "static-1.3480",
  "upgrade-catalog-service-types": "static-1.3533",
  "access-control-lib": "static-1.10449",
  "EmailComponents": "static-1.54798",
  "EmailData": "static-1.53475",
  "redux-less": "static-2.9497",
  "sequences-lib": "static-1.8067",
  "ui-gdpr-components": "static-1.10364",
  "products-ui-components": "static-1.40149",
  "accounting-integrations-ui-components": "static-1.7088",
  "invoices-ui-lib": "static-1.54796",
  "commerce-products-api": "static-1.2316",
  "invoices-iframe-lib": "static-1.56854",
  "quotes-modal-lib": "static-1.102780",
  "quotes-ui-lib": "static-1.80823",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28314",
  "ContentData": "static-1.68490",
  "layout-data-lib": "static-1.9773",
  "hub-http-rxjs": "static-1.802",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3952",
  "billing-payments-client-types": "static-1.4002",
  "react-performance-metrics-lib": "static-1.569",
  "account-and-billing-fintech-outages": "static-3.18607",
  "pricing-pages-api": "static-1.13950",
  "ContentComponents": "static-2.71371",
  "marketing-contacts-lib": "static-1.10101",
  "marketing-email-service-types": "static-1.1919",
  "messaging-editing-lib": "static-1.46328",
  "messaging-usage-based-billing-components-lib": "static-1.1190",
  "automation-ui-source-apps": "static-1.18941",
  "automation-ui-types": "static-1.19859",
  "messaging-types-lib": "static-1.46065",
  "onboarding-settings-client": "static-1.4518",
  "sequences-client-types-lib": "static-1.7924",
  "commerce-tax-lib": "static-1.540",
  "price-books-api": "static-1.802",
  "price-books-components": "static-1.860",
  "property-description-translator": "static-1.3857",
  "ramp-editor": "static-1.185",
  "commerce-analytics-service-client": "static-1.3642",
  "totals-ui-components": "static-1.23648",
  "SalesContentIndexUI": "static-3.9270",
  "advanced-menus-core": "static-1.15149",
  "advanced-menus-lib": "static-1.12088",
  "ui-memberships-settings-lib": "static-1.34095",
  "segments-query-core": "static-1.1432",
  "demographics-service-types": "static-1.1665",
  "eligibility-engine-service-types": "static-1.3197",
  "automation-ui-ubb": "static-1.5775",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7352",
  "data-token-views": "static-1.16414",
  "forms-utils-lib": "static-1.12612",
  "payments-embed-points-lib": "static-1.13067",
  "simple-menus-core": "static-1.15148",
  "simple-menus-lib": "static-1.16665",
  "videoconference-integration-components": "static-1.6840",
  "marketing-contacts-client": "static-1.7530",
  "automation-applications-service-types": "static-1.3521",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77168",
  "short-messages-app-service-client": "static-1.3981",
  "web-interactives-components": "static-1.13785",
  "web-interactives-data": "static-1.13786",
  "messaging-shared-utils-lib": "static-1.639",
  "messaging-user-info-utils-lib": "static-1.809",
  "email-portal-health-service-types": "static-1.991",
  "line-items-api": "static-1.716",
  "commerce-totals-service-types": "static-1.3827",
  "FireAlarmUi": "static-1.4521",
  "sales-templates-service-types-lib": "static-1.4178",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21795",
  "automation-ui-usage-tracking": "static-1.21258",
  "data-studio-ubb": "static-1.2777",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27068",
  "collaboration-sidebar": "static-1.57876",
  "content-management-data-lib": "static-1.5406",
  "copilot-plugins": "static-1.11148",
  "cta-picker": "static-1.36449",
  "customer-agent-discovery-components-lib": "static-1.3132",
  "editor-components": "static-1.13247",
  "editor-iframe-lib": "static-1.8421",
  "error-messaging-js": "static-1.5206",
  "FormsCommonComponents": "static-1.85901",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10659",
  "SharedLegalStrings": "static-1.1760",
  "smart-content-core": "static-1.42491",
  "smart-content-lib": "static-1.43144",
  "social-composer-lib": "static-1.59214",
  "structured-content-lib": "static-1.25239",
  "theme-previewer-lib": "static-1.53305",
  "tinymce-copilot": "static-1.16485",
  "xray-recommendation-lib": "static-1.7925",
  "automation-ui-routing": "static-1.21216",
  "sql-reporting-client-types": "static-1.5652",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42233",
  "campaigns-utils-lib": "static-1.3194",
  "reporting-enablement": "static-1.22987",
  "chatspot-widget-iframe": "static-1.21390",
  "collaboration-sidebar-common": "static-1.2673",
  "forms-ai-lib": "static-1.4340",
  "codemirror-dlb": "static-1.58727",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6445",
  "report-customization-components": "static-1.13218",
  "data-quality-ui-library": "static-1.13078",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.367",
  "reporting-insights-lib": "static-1.1799"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12324",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9681",
  "foundations-components": "/foundations-components/static-1.7964",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.989",
  "foundations-theming": "/foundations-theming/static-1.4433",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8027",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10000",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11485",
  "I18n": "/I18n/static-7.1628",
  "jasmine-runner": "/jasmine-runner/static-1.6477",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12385",
  "quartz": "/quartz/static-1.7050",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16685",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2872",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9555",
  "settings-ui-lib": "/settings-ui-lib/static-1.12534",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7164",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11162",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9555",
  "unified-auth": "/unified-auth/static-1.508",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.790",
  "usage-tracker": "/usage-tracker/static-1.7359",
  "usage-tracker-core": "/usage-tracker-core/static-1.7209",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8104",
  "hub-http": "/hub-http/static-1.6235",
  "integrations-lib": "/integrations-lib/static-1.16202",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19771",
  "property-management-iframe": "/property-management-iframe/static-1.13213",
  "quartz-config": "/quartz-config/static-1.828",
  "quartz-core": "/quartz-core/static-1.6269",
  "quartz-routing": "/quartz-routing/static-1.480",
  "quick-fetch": "/quick-fetch/static-1.3925",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4666",
  "ts-schema": "/ts-schema/static-1.4088",
  "ui-universal-auth": "/ui-universal-auth/static-1.8994",
  "UIComponents": "/UIComponents/static-3.8431",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3408",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3327",
  "quartz-webpack": "/quartz-webpack/static-1.3274",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.128",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4233",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4880",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2149",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9438",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5353",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1989",
  "ui-fonts": "/ui-fonts/static-1.747",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2916",
  "foundations-theming-base": "/foundations-theming-base/static-1.3418",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.762",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3138",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4341",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9022",
  "ai-rendering-library": "/ai-rendering-library/static-1.10234",
  "chirp-fetch": "/chirp-fetch/static-1.1901",
  "connections-embed-lib": "/connections-embed-lib/static-1.1015",
  "copilot-toolkit": "/copilot-toolkit/static-1.11175",
  "feedback-loader": "/feedback-loader/static-1.29320",
  "laboratory-lib": "/laboratory-lib/static-3.7169",
  "marketplace-embed": "/marketplace-embed/static-1.22141",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9667",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19727",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13942",
  "sanitize-text": "/sanitize-text/static-1.8155",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8716",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5773",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5045",
  "wootric-nps": "/wootric-nps/static-1.6988",
  "quartz-head": "/quartz-head/static-1.715",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4665",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4167",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "reporting-data": "/reporting-data/static-1.67622",
  "cssUtils": "/cssUtils/static-1.794",
  "flux-actions": "/flux-actions/static-1.338",
  "HubStyle": "/HubStyle/static-2.11792",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10220",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10379",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7349",
  "icons": "/icons/static-2.648",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18304",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4529",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5447",
  "quartz-i18n": "/quartz-i18n/static-1.725",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.290",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.416",
  "slack-ui-library": "/slack-ui-library/static-1.10406",
  "fsm": "/fsm/static-1.3744",
  "customer-data-objects": "/customer-data-objects/static-1.7683",
  "property-translator": "/property-translator/static-1.5413",
  "hs-locale-management": "/hs-locale-management/static-1.89",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7941",
  "hs-promise-utils": "/hs-promise-utils/static-1.5604",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4893",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13617",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5614",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7795",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4490",
  "superstore": "/superstore/static-1.4775",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10178",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7907",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4660",
  "immutable-less": "/immutable-less/static-1.4667",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17178",
  "nav-meta": "/nav-meta/static-1.29721",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10261",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18015",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3854",
  "property-management-common": "/property-management-common/static-1.5501",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9071",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.725",
  "quartz-test": "/quartz-test/static-1.725",
  "quartz-tracking": "/quartz-tracking/static-1.429",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.76",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21399",
  "ContentUtils": "/ContentUtils/static-1.68415",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13041",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.63",
  "avatar-components": "/avatar-components/static-1.2511",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39852",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13178",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14395",
  "ExportDialog": "/ExportDialog/static-6.10400",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41349",
  "reporting-snowflake": "/reporting-snowflake/static-1.56240",
  "reporting-ui-components": "/reporting-ui-components/static-2.64893",
  "reporting-visualizations": "/reporting-visualizations/static-1.59698",
  "ui-addon-teams": "/ui-addon-teams/static-1.21573",
  "magpie-lib": "/magpie-lib/static-1.5561",
  "navigation-components": "/navigation-components/static-1.18084",
  "magpie-types": "/magpie-types/static-1.5021",
  "simple-logging-lib": "/simple-logging-lib/static-1.3064",
  "ai-studio-lib": "/ai-studio-lib/static-1.11663",
  "app-governance-lib": "/app-governance-lib/static-1.1592",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10523",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8012",
  "ui-product-approvals": "/ui-product-approvals/static-1.28173",
  "ui-tool-access": "/ui-tool-access/static-1.10161",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8971",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5776",
  "usage-tracker-public": "/usage-tracker-public/static-1.7170",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3594",
  "persist-promise": "/persist-promise/static-1.3712",
  "reference-resolvers": "/reference-resolvers/static-1.8184",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3936",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.352",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3026",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2829",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5086",
  "purchase-motions-components": "/purchase-motions-components/static-1.5930",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1555",
  "crm-component-utils": "/crm-component-utils/static-1.39124",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5898",
  "customer-data-properties": "/customer-data-properties/static-1.51611",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6898",
  "property-value-citations": "/property-value-citations/static-1.2225",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8108",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9067",
  "navigation-messaging": "/navigation-messaging/static-1.7411",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9998",
  "cms-field-types": "/cms-field-types/static-1.4826",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9840",
  "events-data-lib": "/events-data-lib/static-1.235",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7260",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22287",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4732",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4013",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6803",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.993",
  "onboarding-tours": "/onboarding-tours/static-1.16640",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13733",
  "academy-common-lib": "/academy-common-lib/static-1.13855",
  "content-assistance-lib": "/content-assistance-lib/static-1.7773",
  "dashboard-lib": "/dashboard-lib/static-1.81598",
  "file-manager-components": "/file-manager-components/static-1.23669",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18507",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18278",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18270",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19860",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8715",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4776",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11053",
  "user-context": "/user-context/static-1.5119",
  "growth-payments-core": "/growth-payments-core/static-1.25430",
  "reporting-plugins": "/reporting-plugins/static-1.10345",
  "reporting-reports": "/reporting-reports/static-1.67300",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.737",
  "nest": "/nest/static-1.241",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10640",
  "framework-listing-lib": "/framework-listing-lib/static-2.28757",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30755",
  "apps-service-types": "/apps-service-types/static-1.3891",
  "oauth-service-types": "/oauth-service-types/static-1.4262",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.68",
  "onboarding-scopes": "/onboarding-scopes/static-1.6475",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4854",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7679",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14953",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3605",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9313",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5933",
  "signup-constants": "/signup-constants/static-1.18866",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8065",
  "trials-service-types": "/trials-service-types/static-1.3916",
  "card-properties-lib": "/card-properties-lib/static-1.44247",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37171",
  "crm-actions": "/crm-actions/static-1.6339",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43639",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9327",
  "customer-data-tracking": "/customer-data-tracking/static-1.6903",
  "hs-resources": "/hs-resources/static-1.166",
  "pulse": "/pulse/static-1.588",
  "calling-global-api": "/calling-global-api/static-1.64567",
  "calling-internal-common": "/calling-internal-common/static-1.31316",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65949",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58243",
  "commerce-products-lib": "/commerce-products-lib/static-1.9631",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3805",
  "crm-links": "/crm-links/static-1.6307",
  "external-options-client-types": "/external-options-client-types/static-1.4167",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4231",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.645",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3699",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48803",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3973",
  "smart-property-lib": "/smart-property-lib/static-1.7158",
  "tiered-pricing": "/tiered-pricing/static-1.1251",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11003",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4147",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.17",
  "react-dnd-compat": "/react-dnd-compat/static-1.4628",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.921",
  "growth-data-modal": "/growth-data-modal/static-1.5450",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3080",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1970",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.706",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7559",
  "academy-service-client": "/academy-service-client/static-1.3694",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39168",
  "FileManagerLib": "/FileManagerLib/static-1.39309",
  "video-embed": "/video-embed/static-1.35821",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28609",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11329",
  "video-data-lib": "/video-data-lib/static-1.34987",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23589",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9901",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24404",
  "viral-links-lib": "/viral-links-lib/static-1.7079",
  "data-token-picker": "/data-token-picker/static-1.16433",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.240",
  "timezone-utils": "/timezone-utils/static-2.5258",
  "seat-types-lib": "/seat-types-lib/static-1.49",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17625",
  "ui-addon-opt": "/ui-addon-opt/static-4.8379",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9171",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7339",
  "customer-data-views-management": "/customer-data-views-management/static-1.25493",
  "framework-data-table": "/framework-data-table/static-2.11949",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6871",
  "nudge-client-utils": "/nudge-client-utils/static-1.2616",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1046",
  "app-users-service-client": "/app-users-service-client/static-1.5611",
  "app-users-service-types": "/app-users-service-types/static-1.5019",
  "mini-checkout-client": "/mini-checkout-client/static-1.26845",
  "onboarding-utils": "/onboarding-utils/static-1.5367",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28594",
  "edison-service-client-types": "/edison-service-client-types/static-1.401",
  "crm_data": "/crm_data/static-4.92020",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46065",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16276",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4270",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19123",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18584",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10421",
  "crm-fe-perf": "/crm-fe-perf/static-1.22917",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.91",
  "directed-graph": "/directed-graph/static-1.949",
  "event-emitter": "/event-emitter/static-1.961",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31323",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11050",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6555",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1034",
  "commerce-permissions": "/commerce-permissions/static-1.783",
  "products-iframe-lib": "/products-iframe-lib/static-1.7984",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10382",
  "data-agent-kit": "/data-agent-kit/static-1.216",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10083",
  "policy-lib": "/policy-lib/static-1.6791",
  "react-tinymce": "/react-tinymce/static-1.55291",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10146",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54417",
  "tinymce-plugins": "/tinymce-plugins/static-1.57531",
  "tinymce-themes": "/tinymce-themes/static-1.56387",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1979",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1998",
  "user-context-client": "/user-context-client/static-1.4626",
  "audio-components": "/audio-components/static-1.5935",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36820",
  "urlinator": "/urlinator/static-1.4550",
  "video-components": "/video-components/static-1.13332",
  "outpost": "/outpost/static-1.4194",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6594",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12373",
  "content-media-compositions": "/content-media-compositions/static-2.16380",
  "media-bridge-lib": "/media-bridge-lib/static-1.18952",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6129",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5096",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3654",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21702",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3856",
  "ts-utils-lib": "/ts-utils-lib/static-1.186",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.706",
  "crm-export-dialog": "/crm-export-dialog/static-1.6305",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6454",
  "crm-view-components": "/crm-view-components/static-1.307",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2373",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2692",
  "whisper-core-api": "/whisper-core-api/static-1.6671",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14861",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5585",
  "settings-content-modals": "/settings-content-modals/static-1.46133",
  "crm_universal": "/crm_universal/static-1.22033",
  "customer-data-email": "/customer-data-email/static-1.18060",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37225",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39594",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12123",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54780",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21518",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17914",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72102",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5356",
  "utility-belt": "/utility-belt/static-1.2548",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22948",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7531",
  "customer-data-rte": "/customer-data-rte/static-1.33042",
  "cv-backend-services": "/cv-backend-services/static-1.1553",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5757",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5122",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38192",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35811",
  "sales-views-client-types": "/sales-views-client-types/static-1.4272",
  "hub-http-contrib": "/hub-http-contrib/static-1.3056",
  "interframe": "/interframe/static-3.4773",
  "tinymce-data": "/tinymce-data/static-1.40502",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5224",
  "layout-dnd-components": "/layout-dnd-components/static-1.12473",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11448",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15341",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9067",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7619",
  "social-insights-client-types": "/social-insights-client-types/static-1.22165",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4155",
  "checkout-sdk": "/checkout-sdk/static-3.23688",
  "checkout-service-types": "/checkout-service-types/static-1.3829",
  "company-details-components": "/company-details-components/static-1.6209",
  "payment-method-components": "/payment-method-components/static-1.6920",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14085",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3480",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3533",
  "access-control-lib": "/access-control-lib/static-1.10449",
  "EmailComponents": "/EmailComponents/static-1.54798",
  "EmailData": "/EmailData/static-1.53475",
  "redux-less": "/redux-less/static-2.9497",
  "sequences-lib": "/sequences-lib/static-1.8067",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10364",
  "products-ui-components": "/products-ui-components/static-1.40149",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7088",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54796",
  "commerce-products-api": "/commerce-products-api/static-1.2316",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56854",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102780",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80823",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28314",
  "ContentData": "/ContentData/static-1.68490",
  "layout-data-lib": "/layout-data-lib/static-1.9773",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.802",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3952",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4002",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.569",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18607",
  "pricing-pages-api": "/pricing-pages-api/static-1.13950",
  "ContentComponents": "/ContentComponents/static-2.71371",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10101",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1919",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46328",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1190",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18941",
  "automation-ui-types": "/automation-ui-types/static-1.19859",
  "messaging-types-lib": "/messaging-types-lib/static-1.46065",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4518",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7924",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.540",
  "price-books-api": "/price-books-api/static-1.802",
  "price-books-components": "/price-books-components/static-1.860",
  "property-description-translator": "/property-description-translator/static-1.3857",
  "ramp-editor": "/ramp-editor/static-1.185",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3642",
  "totals-ui-components": "/totals-ui-components/static-1.23648",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9270",
  "advanced-menus-core": "/advanced-menus-core/static-1.15149",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12088",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34095",
  "segments-query-core": "/segments-query-core/static-1.1432",
  "demographics-service-types": "/demographics-service-types/static-1.1665",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3197",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5775",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7352",
  "data-token-views": "/data-token-views/static-1.16414",
  "forms-utils-lib": "/forms-utils-lib/static-1.12612",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13067",
  "simple-menus-core": "/simple-menus-core/static-1.15148",
  "simple-menus-lib": "/simple-menus-lib/static-1.16665",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6840",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7530",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3521",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77168",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3981",
  "web-interactives-components": "/web-interactives-components/static-1.13785",
  "web-interactives-data": "/web-interactives-data/static-1.13786",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.639",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.809",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.991",
  "line-items-api": "/line-items-api/static-1.716",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3827",
  "FireAlarmUi": "/FireAlarmUi/static-1.4521",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4178",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21795",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21258",
  "data-studio-ubb": "/data-studio-ubb/static-1.2777",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27068",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57876",
  "content-management-data-lib": "/content-management-data-lib/static-1.5406",
  "copilot-plugins": "/copilot-plugins/static-1.11148",
  "cta-picker": "/cta-picker/static-1.36449",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3132",
  "editor-components": "/editor-components/static-1.13247",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8421",
  "error-messaging-js": "/error-messaging-js/static-1.5206",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85901",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10659",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1760",
  "smart-content-core": "/smart-content-core/static-1.42491",
  "smart-content-lib": "/smart-content-lib/static-1.43144",
  "social-composer-lib": "/social-composer-lib/static-1.59214",
  "structured-content-lib": "/structured-content-lib/static-1.25239",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53305",
  "tinymce-copilot": "/tinymce-copilot/static-1.16485",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7925",
  "automation-ui-routing": "/automation-ui-routing/static-1.21216",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5652",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42233",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3194",
  "reporting-enablement": "/reporting-enablement/static-1.22987",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21390",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2673",
  "forms-ai-lib": "/forms-ai-lib/static-1.4340",
  "codemirror-dlb": "/codemirror-dlb/static-1.58727",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6445",
  "report-customization-components": "/report-customization-components/static-1.13218",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13078",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.367",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1799"
}
};
